// #region IMPORTS
import { Material, Object3D } from 'three';

import DynLineMesh from '../shapes/DynLineMesh';
import ShapePointsMesh from '../shapes/ShapePointMesh';

// #endregion

export default class VisualDebug extends Object3D {
  ln = new DynLineMesh();
  pnt = new ShapePointsMesh();

  constructor() {
    super();

    // Set this object
    this.renderOrder = 100;
    this.frustumCulled = false;

    // Line Rendering
    this.ln.renderOrder = 100;
    this.ln.frustumCulled = false;
    (this.ln.material as Material).depthTest = false;
    this.add(this.ln);

    // Point Rendering
    this.pnt.renderOrder = 101;
    this.pnt.frustumCulled = false;
    (this.pnt.material as Material).depthTest = false;
    this.add(this.pnt);
  }

  reset() {
    this.ln.reset();
  }
}
